export const useSearchParam = (param: string): string => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(param) ?? "";
};
